import { render } from "./disciplinerecord.vue?vue&type=template&id=7ded5de0&scoped=true&ts=true"
import script from "./disciplinerecord.vue?vue&type=script&lang=ts"
export * from "./disciplinerecord.vue?vue&type=script&lang=ts"

import "./disciplinerecord.vue?vue&type=style&index=0&id=7ded5de0&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ded5de0"]])

export default __exports__